﻿import common = require("../../../common");
import Vue from 'vue';
import Component from 'vue-class-component'
import HotEditableFormManager = require("./HotEditableFormManager");
import DatePicker from 'vue2-datepicker'
import moment = require('moment');
import context = require("../../context");
import utilities = require("../../utilities");
import HotEditableHelpers = require("./HotEditableHelpers");

declare function require(x: string);
declare function __getHotEditableDatePickerComponentTemplate(): string;

require('vue2-datepicker/locale/fr');
interface IShortcut {
    title: string;
    date: string;
}

/** https://www.npmjs.com/package/vue2-datepicker */
interface IVue2Shortcut {
    text: string;
    onClick: () => Date;
}
/* Types de date supportees par le plugin **/
enum DateTypes {
    date = 'date',
    datetime = 'datetime',
    year = 'year',
    month = 'month',
    time = 'time',
    week = 'week'
}
@Component((
    {
        props:
        {
            initId: String,
            initName: String,
            initClass: String,
            initValue: String,
            initTabIndex: Number,
            initDisplayName: String,
            initRequired: String,
            initDisabled: Boolean,
            initEditModeOn: Boolean,
            initCanChangeEditMode: Boolean,
            initPlaceholder: String,
            initFormat: String,
            initDefaultValue: String,
            initClearable: Boolean,
            initDateType: String,
            initNoSecond: Boolean,
            initDisabledDateBefore: String,
            initDisabledDateAfter: String,
            initOnPreChange: String,
            initShortcuts: String
        }
    }))
/* Inclus le plugin 'vue2-datepicker' **/
class HotEditableDatePickerComponent extends Vue implements common.IHotEditableFieldComponent {
    initId: string;
    initName: string;
    initClass: string;
    initValue: string;
    initTabIndex: number;
    initDisplayName: string;
    initRequired: string;
    initDisabled: string;
    initEditModeOn: boolean;
    initCanChangeEditMode: boolean;
    initLabel: string;
    initDefaultValue: string;
    initPlaceholder: string;
    initFormat: string;
    initClearable: boolean;
    initDateType: string;
    initNoSecond: boolean;
    initDisabledDateBefore: string;
    initDisabledDateAfter: string;
    initOnPreChange: string;
    initShortcuts: string;

    rootId: string;
    editModeOn: boolean;
    canChangeEditMode: boolean;
    elementValue: string;//Date;
    elementDisabled: boolean;
    tabIndex: number;
    required: boolean;
    displayName?: string; //Champ utilisé pour identifier le champ lors des messages aux utilisateurs.
    cssClass: string;
    elementName: string;
    idElement: string;
    label: string;
    placeholder: string; //Message affiché quand le champ n'a pas de sélection en mode edition.
    defaultValue: string;
    format: string;
    hasError: boolean;
    clearable: boolean;
    dateType: DateTypes;
    noSecond: boolean;
    disabledDateBefore?: Date;
    disabledDateAfter?: Date;
    fieldType = common.HotEditableFieldTypes.datePicker;
    datePickerInputClass: string;
    open = false;
    onPreChange: string;
    shortcuts: Array<IVue2Shortcut>;

    _previousValue = null as string;//Date
    _formManagerParent: HotEditableFormManager;//NOTE: Doit undefined initialement car il est definie dans le "beforeCreate"
    //_disableNextChangedAction = false;//NOTE: Previens le double-changed en provenance du input::blur()

    static tagName = "hoteditabledatepicker";
    static prepareMarkup(element: HTMLElement) {

        if (!element)
            throw "[" + this.tagName + "::prepareMarkup] L'element est NULL";

        element.removeAttribute("hot-editable");
        element.setAttribute("hot-editable-cloak", "");

        const newOuterHtml = element.outerHTML.replace('<input ', '<' + this.tagName + ' ')
            .replace(' id=', ' init-id=')
            .replace(' name=', ' init-name=')
            .replace(' class=', ' init-class=')
            .replace(' value=', ' init-value=')
            .replace(' disabled=', ' init-disabled=')
            .replace(' required=', ' init-required=')
            .replace(' display-name=', ' init-display-name=')
            .replace(' tabindex=', ' v-bind:init-tab-index=')
            .replace(' edit-mode-on=', ' v-bind:init-edit-mode-on=')
            .replace(' can-change-edit-mode=', ' v-bind:init-can-change-edit-mode=')
            .replace(' show-label=', ' init-show-label=')
            .replace(' placeholder=', ' init-placeholder=')
            .replace(' default-value=', ' init-default-value=')
            .replace(' date-type=', ' init-date-type=')
            .replace(" clearable=", ' v-bind:init-clearable=')
            .replace(" no-second=", ' v-bind:init-no-second=')
            .replace(' format=', ' init-format=')
            .replace(' disabled-date-before=', ' init-disabled-date-before=')
            .replace(' disabled-date-after=', ' init-disabled-date-after=')
            .replace(' label=', ' init-label=')
            .replace(' on-pre-change=', ' init-on-pre-change=')
            .replace(' shortcuts=', ' init-shortcuts=');

        element.outerHTML = newOuterHtml;
    }

    data() {
        const guid = utilities.createGuid('N');
        const id = this.initId || "Field_" + guid;
        const elementName = this.initName || id;
        const isRequired = this.initRequired === 'required';
        const tabIndex = this.initTabIndex || -1;
        const shortcuts = this.initShortcuts ? JSON.parse(this.initShortcuts) as Array<IShortcut> : [];
        const vue2Shortcuts = [] as Array<IVue2Shortcut>;
        for (let i = 0; i < shortcuts.length; i++) {
            const x = shortcuts[i];
            vue2Shortcuts.push({
                text: x.title,
                onClick: () => this.onShortcutClick(x)
            });
        }

        const o = {
            rootId: "HotEditableField_" + guid,
            idElement: id,
            elementName: elementName,
            editModeOn: this.initEditModeOn === true,
            canChangeEditMode: this.initCanChangeEditMode === true,
            elementValue: this.initValue || '',
            elementDisabled: this.initDisabled === 'disabled',
            tabIndex: tabIndex,
            required: isRequired,
            displayName: this.initDisplayName || null,
            cssClass: this.initClass || '',
            placeholder: this.initPlaceholder || "",
            label: this.initLabel || '',
            defaultValue: this.initDefaultValue || '',
            format: this.initFormat || "YYYY-MM-DD",
            clearable: this.initClearable === true,
            hasError: false,
            noSecond: this.initNoSecond === true,
            onPreChange: this.initOnPreChange || null,
            shortcuts: vue2Shortcuts,
            disabledDateBefore: null,// Sera definie au "mounted"
            disabledDateAfter: null,// Sera definie au "mounted"
            dateType: (this.initDateType ? DateTypes[this.initDateType] : null) || DateTypes.date,
            datePickerInputClass: 'v-datepicker--input cal' + id,
            datePickerInputAttr: {
                id: id,
                name: elementName,
                required: isRequired,
                tabindex: tabIndex
            }
        };

        return o;
    }

    private onShortcutClick(shortcut: IShortcut) { 
        const d = shortcut ? shortcut.date : null;
        return moment(d, this.format).toDate();
    }

    beforeCreate() {
        this._formManagerParent = ((this.$parent as any).formManager as HotEditableFormManager).registerField(this);

        this.$options.template = __getHotEditableDatePickerComponentTemplate();
        this.$options.components = { 'date-picker': DatePicker };
    }

    created() {
        if (utilities.isIe())
            //HACK|IE11: Supprimer le placeholder dans IE11 car celui-ci occasionne le bug de la valeur de date qui ne s'initialise pas (COT-595).
            this.placeholder = null;

        if (this.initDisabled) {
            if (this.cssClass.indexOf(' disabled') < 0)
                this.cssClass += ' disabled';
        }
    }

    mounted() {
        HotEditableHelpers.validateFieldSettings(this);

        (this.$el as Element).removeAttribute("hot-editable-cloak");

        this.disabledDateBefore = this.initDisabledDateBefore ? this.toDateFromTextualValue(this.initDisabledDateBefore) : null;
        this.disabledDateAfter = this.initDisabledDateAfter ? this.toDateFromTextualValue(this.initDisabledDateAfter) : null;

        this.updatePreviousValue();

        //permet de faire fonctionner les esc/tab/enter
        document.addEventListener("keydown", e => {

            if (!this.canChangeEditMode || !this.editModeOn)
                return;

            //const isEnter = this.canChangeEditMode && this.editModeOn ? false : utilities.isEnterKeyCode(e);
            const isEnter = utilities.isEnterKeyCode(e);
            const isEscape = !isEnter && utilities.isEscapeKeyCode(e);
            const isTab = !isEnter && !isEscape && utilities.isTabKeyCode(e);

            if (isEnter || isEscape || isTab) {
                this.preventDefault(e);

                const isShifted = e.shiftKey;

                if (isShifted) {
                    if (isTab)
                        setTimeout(() => {
                            this.onShiftTabClick(e);
                        }, 1);
                } else {
                    if (isEscape)
                        this.onEscapeClick(e);
                    else if (isTab)
                        setTimeout(() => {
                            this.onTabClick(e);
                        }, 1);
                    else if (isEnter)
                        this.onEnterClick(e);
                }
            }
        });

        // permet de faire fonctionner le blur
        document.addEventListener("mousedown", e => {
            if (!this.canChangeEditMode || !this.editModeOn)
                return;

            const currentElement = e.target as Element;
            const popupEl = this.getPopupElement();

            if (popupEl && utilities.isOutside(currentElement, popupEl)) {
                this.onBlur(e);
                return;
            }
        });
    }

    isDisabledDate(date: Date) {
        return (this.disabledDateBefore && date < this.disabledDateBefore) || (this.disabledDateAfter && date > this.disabledDateAfter);
    }

    getPopupElement() {
        const elements = document.getElementsByClassName('mx-datepicker-popup');
        return elements.length ? elements[0] : null;
    }

    updatePreviousValue(value?: any) {
        this._previousValue = value || value === '' || value === 0 || value === false ? value : this.elementValue;
        return this;
    }

    changeMode(canChangeEditMode: boolean, editModeOn: boolean) {
        this.updatePreviousValue();
        this.canChangeEditMode = canChangeEditMode;
        this.editModeOn = editModeOn
    }

    getInput() {
        const $input = $(this.$el).find('input').first();
        return $input;
    }

    getInputElement() {
        const $input = this.getInput();
        return $input.length ? $input[0] : null;
    }
    private evalOnPreChange() {
        if (this.onPreChange)
            eval(this.onPreChange);
        return this;
    }
    onFocusoutNative() {
        //this.changed();
    }

    onChanged(event: Event) {
        this.preventDefault(event);
        this.changed();
    }

    onCancel(event: Event) {
        this.preventDefault(event);
        this.cancel();
    }

    onClear(event: Event) {
        this.preventDefault(event);
        this.clear();
    }
    private preventDefault(e?: Event, bypassStopPropagation?: boolean) {
        if (!e)
            return;

        e.preventDefault();

        if (bypassStopPropagation !== true)
            e.stopPropagation();
    }
    clear() {
        this.elementValue = null;
    }

    isDisabled(value?: boolean) {
        value = value !== false;

        if (this.elementDisabled === value)
            return this;

        this.elementDisabled = value;

        return this;
    }

    changed() {

        this.$nextTick(() => {
            this.innerChanged();
        });
    }

    private innerChanged() {

        if (this.canChangeEditMode) {
            this.editModeOn = false;
            this._formManagerParent.editModeChanged(this);

            if ((this.elementValue || '') === this._previousValue)
                return;
        }

        this._formManagerParent.fieldChanged(this);
    }

    pluginChanged(date: any) {

        this.evalOnPreChange();
        this.changed();
    }

    setFromTextualValue(textualValue?: string) {

        this.updatePreviousValue();

        this.elementValue = textualValue || null;

        if (utilities.isIe()) {
            const dp = (this.$refs["datepicker"] as any).$el as Element;
            const input = dp.querySelector('.mx-input-wrapper input') as HTMLInputElement;

            input.value = textualValue || '';
        }

        // POUR TESTER...
        //searchBox:
        //    main.context.components.items[0]._searchBox._searchBoxFiltersVue.formManager.getFieldByName('DateFin').elementValue = '2020-02-03'
        //form:
        //    main.context.components.items[0]._defaultEditVue.formManager.getFieldByName('DateDebut').elementValue = '2020-03-10'

        return this;
    }

    getTextualValue() {
        const r = this.formatDateFromString(this.elementValue);
        return r || '';
    }

    getDisplayedDate(elementValue: string) {

        const formated = this.formatDateFromString(elementValue);

        if (!formated)
            return '';

        if (this.dateType === DateTypes.datetime)
            return formated.replace(' ', '<br />');

        return formated;
    }


    formatDateFromString(textualDate?: string) {
        const date = this.toDateFromTextualValue(textualDate);

        if (!date)
            return null;

        const formated = this.formatDate(date);

        return formated;
    }

    private toDateFromTextualValue(textualDate?: string) {
        if (!textualDate)
            return null;

        const md = moment(textualDate, context.formats.dateTimeMomentDetault);
        const y = md.year();
        const m = md.month();
        const d = md.date();
        const hh = md.hour();
        const mm = md.minute();
        const ss = md.second();
        const ms = 0;// Miliseconds non-considerees
        const date = new Date(y, m, d, hh, mm, ss, ms);
        return date;
    }

    formatDate(date: Date) {
        if (!date)
            return null;

        const addPadding = (x: number) => x < 10 ? '0' + x : x.toString();
        const md = moment(date, '');
        var y = md.year();
        var m = md.month() + 1;
        var d = md.date();

        var res = "{y}-{m}-{d}"
            .replace('{y}', y.toString())
            .replace('{m}', addPadding(m))
            .replace('{d}', addPadding(d));

        if (this.dateType === DateTypes.datetime) {
            var hh = md.hour();
            var mm = md.minute();
            var ss = md.second();

            res += ' {hh}:{mm}'
                .replace('{hh}', addPadding(hh))
                .replace('{mm}', addPadding(mm));

            if (!this.noSecond)
                res += ':{ss}'.replace('{ss}', addPadding(ss));
        }

        return res;
    }
    editClick(event?: Event, forcedMode?: boolean) {
        if (!this.canChangeEditMode)
            return;

        this.updatePreviousValue();

        if (this.editModeOn)
            this.manualyUpdateFromInputValue();

        const inputEl = document.getElementById(this.elementName);//<= avec v3.3.0+

        inputEl.click();

        if (forcedMode === true || forcedMode === false) {
            //> forcedMode is setted
            this.editModeOn = forcedMode;
        } else { //> forcedMode is not setted
            //> toggle
            this.editModeOn = !this.editModeOn;
        }

        this._formManagerParent.editModeChanged(this);

        this.focus();


    }

    onEnterClick(event?: KeyboardEvent) {
        //if (this.canChangeEditMode)//NOTE: Ne jamais poster le form au 'Enter' click.
        this.preventDefault(event, this.canChangeEditMode);

        this.manualyUpdateFromInputValue();
        this.showPopup(false);
        this.changed();
    }

    onEscapeClick(event?: KeyboardEvent) {
        if (this.canChangeEditMode)
            this.preventDefault(event, true);

        this.showPopup(false);
        this.cancel();
    }

    onTabClick(event?: KeyboardEvent) {
        //NOTE: Not used in the textbox because the tab has a builtin behavior to blur and blur() method will call the changed() method.
        //this.focusNextComponent();

        if (this.canChangeEditMode)
            this.preventDefault(event, true);

        this.tabulate();
    }

    onShiftTabClick(event?: KeyboardEvent) {
        //NOTE: Not used in the textbox because the tab has a builtin behavior to blur and blur() method will call the changed() method.
        //this.focusNextComponent(true);

        if (this.canChangeEditMode)
            this.preventDefault(event, true);

        this.tabulate(true);
    }

    private tabulate(isShiftTab?: boolean) {
        isShiftTab = isShiftTab === true;

        this.focusNextComponent(!isShiftTab);
    }

    private focusNextComponent(getPrevious?: boolean) {
        getPrevious = getPrevious === true;

        if (!this.canChangeEditMode)
            return false;

        this.manualyUpdateFromInputValue();
        this.innerChanged();
        this.showPopup(false);
        this.editClick(null, false);

        // obligatoire car anim open/close
        setTimeout(() => {
            if (getPrevious)
                this._formManagerParent.focusPreviousComponentFromField(this)
            else
                this._formManagerParent.focusNextComponentFromField(this);
        }, 250);
    }

    cancel() {
        if (!this.canChangeEditMode)
            return;

        this.elementValue = this._previousValue;

        this.editModeOn = false;

        //NOTE: Le "blur()" va lancer le "changed()"
        //this.$root.$emit('hotEditableTextbox-editModeChanged', this);
    }

    onBlur(event?: Event) {
        this.preventDefault(event, true);
        this.blur();
    }

    blur() {
        this.manualyUpdateFromInputValue();
        this.changed();
    }

    private manualyUpdateFromInputValue() {
        const inputEl = this.getInputElement();

        if (!inputEl)
            return;

        const inputValue = (inputEl.value || '').trim();

        if (this.elementValue === inputValue)
            return;

        const isValid = moment(inputValue, this.format, true).isValid();

        if (!isValid)
            return;

        this.elementValue = inputValue;
    }

    confirm() {
    }

    focus() {
        this.$nextTick(() => {
            const $input = $(this.$el).find('input').first();
            $input.trigger('focus');
        });
    }

    /** Permet de mettre a jour un champs frere. L'argument 'valueProcessor' permet de formatter la textualValue (null et undefined signifnient "ne pas mettre a jour"). */
    updateBrotherFromCurrentValue(brotherElementName: string, valueProcessor?: (currentValue: string, currentTextualValue: string) => string) {
        if (!brotherElementName)
            return;
        const brother = this._formManagerParent.getFieldByName(brotherElementName);
        if (!brother)
            return;
        const currentTextualValue = this.getTextualValue();
        var textualValue: string;
        if (valueProcessor) {
            textualValue = valueProcessor(this.elementValue, currentTextualValue);
            if (!textualValue && textualValue !== '')
                return;// no update
        } else {
            textualValue = currentTextualValue;
        }
        brother.setFromTextualValue(textualValue);
    }
    private showPopup(value?: boolean) {
        this.open = value !== false;//Default is TRUE
        return this;
    }
}

export = HotEditableDatePickerComponent;